module.exports = __webpack_public_path__ + "img/9788965457213.f57d8578.jpg";